import { Heading, HeadingLevel } from "@ariakit/react";
import cn from "classnames";
import Link from "next/link";

import type { TemplateProps } from ".";

import teaserStyles from "../../Teaser.module.scss";
import teaserTextStyles from "../../TeaserText/TeaserText.module.scss";
import styles from "../TeaserInjectableNative.module.scss";
import { Icon } from "../../../Icon/Icon";
import { TeaserImage } from "../../TeaserImage/TeaserImage";

const ContentDisplayTemplate = ({
  ad,
  layout,
  open,
  advertisingConsent,
  modal,
}: TemplateProps) => {
  return (
    <article
      className={cn([
        teaserStyles.teaserContainer,
        styles.container,
        styles[`container--${layout}`],
        styles[`container-background--contentDisplay`],
      ])}
    >
      <div
        className={cn([
          styles.label,
          styles[`label--contentDisplay`],
          styles[`label--${layout}`],
          styles["label-text"],
          styles["label-text--contentDisplay"],
          styles["label-text-vignette"],
        ])}
      >
        <div>Annons</div>
        <div
          role="button"
          onClick={(e) => {
            open(e);
          }}
          className={cn([styles.icon, styles.button])}
        >
          <Icon variant="dots" isNative ariaLabel="Inställningar" />
        </div>
      </div>
      <Link
        target="_blank"
        href={ad.clickUrl}
        onClick={() => {
          if (advertisingConsent) {
            ad.clickTrackers.map((ct) => fetch(ct));
          }
        }}
        className={teaserStyles.teaserLargeImage}
        prefetch={false}
      >
        <div
          className={cn([
            teaserStyles.teaser,
            teaserStyles["regular"],
            styles.teaser,
            styles[layout],
          ])}
        >
          <HeadingLevel>
            {ad?.image?.url && (
              <TeaserImage
                size={layout}
                imageUrl={ad.image.url}
                style="regular"
                hasPriorityImage
              />
            )}
            <div
              className={cn([
                teaserStyles.teaserContent,
                styles[`content--${layout}`],
              ])}
            >
              <div
                className={cn([
                  teaserStyles["regular"],
                  teaserStyles.teaserTextContent,
                ])}
              >
                <HeadingLevel>
                  <Heading
                    className={cn([
                      styles.title,
                      styles["title--contentDisplay"],
                      styles[`title--${layout}`],
                    ])}
                  >
                    {ad.title}
                  </Heading>
                </HeadingLevel>
                <p
                  className={cn([
                    styles.text,
                    teaserTextStyles.teaserText,
                    styles["text--contentDisplay"],
                  ])}
                >
                  {ad.body}
                </p>
                <div className={styles.footer}>
                  {`Extern länk | ${ad.sponsoredBy}`}
                </div>
              </div>
            </div>
          </HeadingLevel>
        </div>
      </Link>
      {modal}
    </article>
  );
};

export { ContentDisplayTemplate };
